import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import generalDataManager from "@lib/data/managers/flights/general-data-manager";
import "styles/hacks/mui-noched-outline-hack.css";
import MuscleAutocompleteInput from "@modules/shared/components/autocomplete-input";
import { useEffect, useState } from "react";
import APP_CONFIGURATION from "@lib/app.config";
import { concatAllString } from "@lib/util/string-ops";
import Icons from "@modules/icons";
import { useLocale } from "next-intl";
const parseFlightInfoLocationDataToAutocompleteOption = (_flightInfoLocationData, _lang) => {
  var _flightInfoLocationDa, _flightInfoLocationDa2;
  const flightInfoLocationData = _objectSpread({}, _flightInfoLocationData);
  const lang = _lang.toLowerCase();
  // Municipality by translation priority
  const priorityMunicipality = [flightInfoLocationData.municipality_es, flightInfoLocationData.municipality_en];
  const municipalityByLang = {
    'es': flightInfoLocationData.municipality_es,
    'en': flightInfoLocationData.municipality_en
  };
  if (!flightInfoLocationData.municipality) {
    var _ref, _municipalityByLang$l;
    flightInfoLocationData.municipality = (_ref = (_municipalityByLang$l = municipalityByLang[lang]) !== null && _municipalityByLang$l !== void 0 ? _municipalityByLang$l : priorityMunicipality.find(municipality => municipality)) !== null && _ref !== void 0 ? _ref : '';
  }
  return {
    id: (_flightInfoLocationDa = flightInfoLocationData.iata_code) !== null && _flightInfoLocationDa !== void 0 ? _flightInfoLocationDa : "",
    title: (_flightInfoLocationDa2 = flightInfoLocationData.name) !== null && _flightInfoLocationDa2 !== void 0 ? _flightInfoLocationDa2 : "",
    subTitle: concatAllString(', ', flightInfoLocationData.municipality, flightInfoLocationData.country_name),
    group_key: concatAllString(', ', flightInfoLocationData.municipality, flightInfoLocationData.country_name),
    value: flightInfoLocationData
  };
};
const IatasAutocompleteInput = _ref2 => {
  let {
    identifier,
    label,
    updateFlightInfo,
    flightInfoLocationData,
    hasErrors,
    errorMessage,
    dataTestId,
    excludeIataCode,
    onClick,
    disablePopper,
    customInputClass,
    className,
    disableLabelAnimation = false,
    disableXButton = false,
    useBorderlessStyle = false
  } = _ref2;
  const lang = useLocale();
  const {
    0: value,
    1: setValue
  } = useState(flightInfoLocationData ? parseFlightInfoLocationDataToAutocompleteOption(flightInfoLocationData, lang) : undefined);
  useEffect(() => {
    setValue(flightInfoLocationData ? parseFlightInfoLocationDataToAutocompleteOption(flightInfoLocationData, lang) : undefined);
  }, [flightInfoLocationData, lang]);
  const getIatasByText = async search_text => {
    const data = await generalDataManager.getAirportsByText(search_text);
    if (Array.isArray(data) && data.length === 0) {
      return [];
    } else if (Array.isArray(data)) {
      const filteredData = excludeIataCode ? data.filter(item => item.iata_code !== excludeIataCode) : data;
      return parseData(filteredData);
    } else {
      return [];
    }
  };
  const parseData = data => {
    return data.map(item => {
      return parseFlightInfoLocationDataToAutocompleteOption(item, lang);
    });
  };
  const onSelectOption = selectedOption => {
    if (selectedOption) {
      setValue(selectedOption);
      updateFlightInfo(selectedOption);
    } else {
      // Handle clearing the selection
      updateFlightInfo({
        id: "",
        title: "",
        value: undefined
      });
    }
  };
  return __jsx(MuscleAutocompleteInput, {
    customInputClass: customInputClass || APP_CONFIGURATION.config.forms.search_input_class,
    identifier: identifier,
    label: label,
    hasErrors: hasErrors,
    errorMessage: errorMessage,
    value: value,
    onSelectOption: onSelectOption,
    getOptions: getIatasByText,
    inputLabelIcon: __jsx(Icons.locationPin, {
      size: APP_CONFIGURATION.config.inputsIconSize,
      className: "text-general-general_text"
    }),
    optionsIcon: __jsx(Icons.airplane, {
      size: APP_CONFIGURATION.config.autoCompleteOptionsIconSize,
      className: "text-general-general_text"
    }),
    className: className || APP_CONFIGURATION.config.font,
    dataTestId: dataTestId,
    onClick: onClick,
    disablePopper: disablePopper,
    disableLabelAnimation: disableLabelAnimation,
    disableXButton: disableXButton,
    useBorderlessStyle: useBorderlessStyle,
    groupIcon: __jsx(Icons.locationPin, {
      size: APP_CONFIGURATION.config.autoCompleteGroupIconSize
    }),
    groupKey: "municipality"
  });
};
export default IatasAutocompleteInput;